import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Cloud infrastructure icon.
 *
 * A cloud shape (rounded bumps on top, flat bottom). Represents
 * cloud infrastructure / deployment target.
 *
 * Dual-tone layered:
 * - Outlines: currentColor, 2px stroke, round caps/joins
 * - Cloud body: cyan accent fill at 10%
 */
export const CloudIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Cloud shape: rounded bumps on top, flat bottom */}
    <path
      d="M7 18 L17 18 C19.2 18 21 16.2 21 14 C21 11.8 19.2 10 17 10 C16.8 7.2 14.5 5 11.7 5 C8.7 5 6.3 7.5 6.3 10.3 C4.3 10.6 3 12.3 3 14.3 C3 16.4 4.8 18 7 18 Z"
      fill="#00d4ff"
      fillOpacity={0.1}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

CloudIcon.displayName = "CloudIcon";

export default CloudIcon;
